export type TableIndexTypes =
    | "btree" // Postgres
    | "hash" // Postgres
    | "gist" // Postgres
    | "spgist" // Postgres
    | "gin" // Postgres
    | "brin" // Postgres
